// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

const {
  REACT_APP_FIREBASE_APIKEY: FIREBASE_APIKEY,
  REACT_APP_FIREBASE_APPID: FIREBASE_APPID,
  REACT_APP_FIREBASE_DOMAIN: FIREBASE_DOMAIN,
  REACT_APP_FIREBASE_MEASUREMENT: FIREBASE_MEASUREMENT,
  REACT_APP_FIREBASE_SENDERID: FIREBASE_SENDERID
} = process.env

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: FIREBASE_APIKEY,
  authDomain: `${FIREBASE_DOMAIN}.firebaseapp.com`,
  projectId: FIREBASE_DOMAIN,
  storageBucket: `${FIREBASE_DOMAIN}.appspot.com`,
  messagingSenderId: FIREBASE_SENDERID,
  appId: FIREBASE_APPID,
  measurementId: FIREBASE_MEASUREMENT
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)
